// Module
var code = "<div id=\"dialogBorrarInspDis\"> <p>{{ 'mensajes.confirma_borrar' | lang:'get':{'recurso' : 'nombres.el:choice:1;nombres.inspector:choice:1' } }}</p> </div>";
// Exports
module.exports = code;